import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { HomePageService } from './Homepage/Homepage.service';
import { AboutBannarService } from 'src/app/components/about/aboutbannar/aboutbannar.service';
import { eventpageService } from 'src/app/components/eventpage/eventpage.service';
import { ContactUsService } from 'src/app/components/about/service/ContactUs.service';
import { PublicService } from 'src/app/components/PublicationsPage/PublicationsPage.service';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from 'xng-breadcrumb';


@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent {
  DataHome: any;
  DataAbout: any;
  Datapublic: any;
eventdata: any;
contactData: any;
  pupdata: any;
  constructor(private elementRef: ElementRef,
    private _HomePageService:HomePageService,
    private _AboutBannarService:AboutBannarService,
    private _eventpageService:eventpageService,
        private _ContactUsService:ContactUsService,
        private _PublicService:PublicService,
        private breadcrumbService: BreadcrumbService,
        private _router :ActivatedRoute,


  ) {
    this._router.queryParams.subscribe((res)=>{
      if(res != undefined){
        console.log("mrt", res['breadcrumbTitle'])
        this.breadcrumbService.set('/contactUs', res['breadcrumbTitle'])
      }
    }
  )
    this._PublicService.watch().valueChanges.subscribe((result:any)=>{
      this.pupdata = result['data']['queryPublicationsPageContents'];
      console.log("pupMartina",result);
    })
    this._eventpageService.watch().valueChanges.subscribe((resultt:any)=>{
      this.eventdata = resultt['data']['queryEventsPageContents'];
      console.log("eventdata", this.eventdata);
    })
    this._HomePageService.watch().valueChanges.subscribe((res:any)=>{
      this.DataHome = res['data']['queryHomepageContents'];
      console.log("HomeMArt", this.DataHome);
    })
    this._AboutBannarService.watch().valueChanges.subscribe((result:any)=>{
      this.DataAbout = result['data']['queryAboutContents'];
      console.log("aboutMArt", this.DataAbout);
    })
    this._ContactUsService.watch().valueChanges.subscribe((result:any)=>{
 
      if((result != undefined)&&(result['data']['queryContactUsContents']?.length>0)){
        this.contactData = result['data']['queryContactUsContents'][0];
      }
      console.log("conttina", this.contactData)
    });
  }
    @Input() imglogoUrl !:string ;


  isScrolled: boolean = false;

  showMegaMenu:boolean =false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
    
    // Select SVG elements with the class .inverted-svg-icon outside of the scroll event handler
    const svgElements: NodeListOf<HTMLElement> = this.elementRef.nativeElement.querySelectorAll('.inverted-svg-icon');
  
    // Change fill color based on scroll position
    const fillColor = this.isScrolled ? 'black' : 'white';
    svgElements.forEach((svg: HTMLElement) => {
      svg.setAttribute('fill', fillColor);
    });
  }


  handleMegamenu() {
    this.showMegaMenu = !this.showMegaMenu;
  }

}